var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loader'),_c('div',{staticClass:"creator"},[_c('product-canvas'),(_vm.showNavigation)?_c('navigation'):_vm._e()],1),(null !== _vm.routeComponent)?_c(_vm.routeComponent,_vm._b({tag:"component"},'component',_vm.routeProps,false)):_vm._e(),_c('modals-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }